import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_GuestinforequestListComponent from "../components/_FM_guestinforequest/_FM_GuestinforequestListComponent";
import _FM_GuestinforequestFormComponent from "../components/_FM_guestinforequest/_FM_GuestinforequestFormComponent";
import _FM_GuestinforequestShowComponent from "../components/_FM_guestinforequest/_FM_GuestinforequestShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_GuestinforequestPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();

  useEffect(() => {
    document.title = t('guestinforequest') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/guest-information-request-page')
  }, []);

  return (
    <div className="_FM_GuestinforequestPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/guest-information-request-page"}/>
      <Panel>
        <_FM_GuestinforequestListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'update' || action === 'create'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                navigate(-1)
               }}>
        <_FM_GuestinforequestFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <_FM_GuestinforequestShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_GuestinforequestPage);
